import { render, staticRenderFns } from "./GlobalSuccess.vue?vue&type=template&id=623c044b"
import script from "./GlobalSuccess.vue?vue&type=script&lang=js"
export * from "./GlobalSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623c044b')) {
      api.createRecord('623c044b', component.options)
    } else {
      api.reload('623c044b', component.options)
    }
    module.hot.accept("./GlobalSuccess.vue?vue&type=template&id=623c044b", function () {
      api.rerender('623c044b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/globals/GlobalSuccess.vue"
export default component.exports